module.exports = __webpack_public_path__ + "img/register-pict.8cdff8b3.png";